export const Deaths = 1;
export const DALYs = 2;
export const YLDs = 3;
export const YLLs = 4;
export const Prevalence = 5;
export const Incidence = 6;
